module.exports = __webpack_public_path__ + "img/detail-btn-bg.7f20c64.png";